import { NotchTextarea } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

/**
 * Verification harness for NotchTextarea — the multi-line field in the notch.
 * Verify in a real browser (shape() clip): the keyline ring traces the notch,
 * goes accent on focus + destructive on aria-invalid, and vertical resize stays
 * inside the notched silhouette.
 */
export function NotchTextareaDemo() {
  return (
    <Section
      id="notch-textarea"
      title="NotchTextarea"
      description="The multi-line field in the hex-notch silhouette — sibling to NotchedInput for descriptions and longer notes. Same keyline contract: nx-rim ring (a real border is sliced at the notch), hairline → accent on focus → destructive on aria-invalid, + accent focus glow. Vertical-only resize so a drag never escapes the notch. Sizes sm/default/lg; ref forwards to the <textarea>."
    >
      <VariantBlock
        label="States — rest · focus · invalid"
        caption="the keyline ring is the focus affordance"
      >
        <div className="flex max-w-md flex-col gap-3">
          <NotchTextarea placeholder="Describe this Studio…" />
          <NotchTextarea placeholder="Focused (autofocus)" autoFocus />
          <NotchTextarea aria-invalid defaultValue="too short" rows={2} />
        </div>
      </VariantBlock>

      <VariantBlock label="Size — sm · default · lg" caption="padding + type scale">
        <div className="flex max-w-md flex-col gap-3">
          <NotchTextarea size="sm" rows={2} placeholder="Small" />
          <NotchTextarea size="default" rows={2} placeholder="Default" />
          <NotchTextarea size="lg" rows={2} placeholder="Large" />
        </div>
      </VariantBlock>
    </Section>
  );
}
